export type GlassType =
  | 'pint'
  | 'tulip'
  | 'mug'
  | 'nonic'
  | 'flute'
  | 'pilsner'
  | 'snifter'
  | 'teku'
  | 'weizen';

const GLASS_BASE_PATH = '/images/glasses';

export const glassAssetPaths: Record<GlassType, string> = {
  pint: `${GLASS_BASE_PATH}/Pint.png`,
  tulip: `${GLASS_BASE_PATH}/Tulip.png`,
  mug: `${GLASS_BASE_PATH}/Mug.png`,
  nonic: `${GLASS_BASE_PATH}/Nonic.png`,
  flute: `${GLASS_BASE_PATH}/Flute.png`,
  pilsner: `${GLASS_BASE_PATH}/Pilsner.png`,
  snifter: `${GLASS_BASE_PATH}/Snifter.png`,
  teku: `${GLASS_BASE_PATH}/Teku.png`,
  weizen: `${GLASS_BASE_PATH}/Weizen.png`,
};

/**
 * Mapping from Firestore beerStyles.type to glass type.
 * Ported from mobile BeerStyleGlassMapping.
 */
export const typeToGlass: Record<string, GlassType> = {
  'Amber & Red': 'pint',
  'Belgian Ales': 'tulip',
  'Blonde & Golden Ales': 'pint',
  Bocks: 'mug',
  'Brown Ale': 'nonic',
  'Dark Ales': 'tulip',
  'Farmhouse Ales': 'tulip',
  'Fruit & Spice Beers': 'flute',
  'India Pale Ales (IPA)': 'tulip',
  IPA: 'tulip',
  IPAs: 'tulip',
  Lagers: 'mug',
  'Non-Alcoholic': 'pint',
  'Pale Ales': 'pint',
  Pilsners: 'pilsner',
  Porters: 'nonic',
  'Sour & Wild Beers': 'snifter',
  'Specialty Beers': 'teku',
  Stouts: 'snifter',
  'Wheat Beers': 'weizen',
  Other: 'pint',
  'Other Styles': 'pint',
};

/**
 * Returns the asset path for a Firestore beerStyles.type.
 * Falls back to Pint for unmapped types.
 */
export function getGlassAssetPathForStyleType(styleType: string): string {
  const normalized =
    typeof styleType === 'string' ? styleType.trim() : '';
  const glassType = typeToGlass[normalized] ?? 'pint';
  return glassAssetPaths[glassType] ?? glassAssetPaths.pint;
}

/**
 * Resolves glass asset path from beer style id and style meta map.
 */
export function getGlassAssetPathForBeer(
  styleId: string | undefined,
  styleMetaMap: Record<string, { type?: string }>,
): string {
  if (typeof styleId !== 'string' || styleId.length === 0) {
    return glassAssetPaths.pint;
  }
  const styleType = styleMetaMap[styleId]?.type ?? '';
  return getGlassAssetPathForStyleType(styleType);
}
